var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"cellspacing":"0","cellpadding":"0","border":"0","width":"100%"}},[_c('thead',[_c('tr',_vm._l((_vm.titles),function(item){return _c('th',[_c('div')])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.datas),function(item){return _c('tr',[_c('td')])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f90e5ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/units/TableList.vue
// module id = null
// module chunks = 